module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image6.813221e0.jpg";